import logo from "@assets/images/logo.svg";
import PromoBanner from "@components/AppBar/PromoBanner";
import HamburgerMenu from "@components/HamburgerMenu";
import UserAvatar from "@components/UserAvatar";
import { UserContext } from "@context/User/UserContext";
import { useTheme } from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";

const AppBar = () => {
  const theme = useTheme();
  const userContext = React.useContext(UserContext);
  const isLoggedIn = Boolean(
    userContext?.user?.email && userContext.user.email.trim() !== ""
  );
  const isSubscriber = Boolean(userContext?.isSubscriber);

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
        backgroundColor: theme.palette.background.paper,
        "@media (max-width: 600px)": {
          paddingTop: {
            xs: "max(env(safe-area-inset-top, 0px), 20px)",
            sm: 0
          },
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: theme.palette.background.paper,
            zIndex: -1
          }
        }
      }}
    >
      <MuiAppBar
        position="static"
        elevation={0}
        sx={{
          height: theme.customLayoutHeight.appNavBarHeight,
          backgroundColor: theme.palette.background.paper,
          boxShadow: theme.shadows[0],
          borderBottom: "none",
          opacity: 1,
          backgroundImage: "none"
        }}
      >
        <Container
          maxWidth={false}
          sx={{
            height: "inherit",
            position: "relative",
            maxWidth: { xs: "100%", sm: 1200 },
            mx: "auto"
          }}
        >
          <Toolbar
            disableGutters
            sx={{
              display: "flex",
              height: "inherit",
              alignItems: "center",
              justifyContent: "space-between",
              position: "relative"
            }}
          >
            {/* Izquierda: Menú hamburguesa (solo si hay sesión) */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexBasis: "33.33%",
                minWidth: { xs: 80, sm: 160 }
              }}
            >
              {isLoggedIn && (
                <HamburgerMenu color={theme.palette.text.primary} />
              )}
            </Box>

            {/* Logo centrado absoluto */}
            <Box
              sx={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                display: "flex",
                alignItems: "center",
                zIndex: 1
              }}
            >
              <Box
                component="img"
                src={logo}
                alt="Xatbot"
                sx={{
                  height: {
                    xs: "32px",
                    sm: "48px"
                  },
                  width: "auto",
                  objectFit: "contain"
                }}
              />
            </Box>

            {/* Derecha: UserAvatar */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                flexBasis: "33.33%",
                minWidth: { xs: 80, sm: 160 },
                gap: 1
              }}
            >
              {isLoggedIn && <UserAvatar color={theme.palette.text.primary} />}
            </Box>
          </Toolbar>
        </Container>
      </MuiAppBar>
      {isLoggedIn && <PromoBanner isSubscribed={isSubscriber} />}
    </Box>
  );
};

export default AppBar;
